function isPatientMenuRendered() {
	const patientMenus = document.getElementsByClassName("nexus-layout-patient-menu");
	return patientMenus.length > 0;
}

export default isPatientMenuRendered;
